import React from 'react';
import classNames from 'classnames';
import Icons from '../../../components/Icons/Icons';

import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

import css from './SharedComponents.module.css';
import { useListingPageContext } from '../context/ListingPageContext';
import { closeListing, rewardListingsSelector } from '../ListingPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { isArrayLength } from '../../../util/genericHelpers';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { createResourceLocatorString } from '../../../util/routes';
import ListingPageActionButtons from '../ListingPageActionButtons';
import { EDIT, REWARD } from '../../../util/constants';
import { createSlug } from '../../../util/urlHelpers';
import { getListingSports, getRewardAvailability } from '../../../util/listingDataExtraction';
import { RewardAvailability } from '../../../util/enums';

function Step({ listing, isOwnListing, dispatch, history, routeConfiguration, profileImageIcon }) {
  const { title, description, publicData = {} } = listing?.attributes || {};
  const { rewardExpirationDate, redemptionInstructions, rewardCode } = publicData || {};
  const handleEdit = () => {
    history.push({
      pathname: createResourceLocatorString(
        'EditRewardsPage',
        routeConfiguration,
        { id: listing?.id?.uuid, slug: createSlug(title), type: EDIT },
        {}
      ),
    });
  };

  const handleDelete = async () => {
    await dispatch(closeListing(REWARD, listing?.id?.uuid));
  };
  return (
    <div className={css.couponBlock}>
      <div className={css.blockTopInfo}>
        <div className={css.offerNameSec}>
          <div className={css.offerImgSec}>
            <img src={profileImageIcon} alt="img" />
          </div>
          <div className={css.offerInfoSec}>{title && <h3>{title}</h3>}</div>
        </div>
        {description && <p>{description}</p>}
        {rewardCode && (
          <div>
            <strong>
              <FormattedMessage id="RenderCouponOffer.cuponCode" />
            </strong>
            {rewardCode}
          </div>
        )}
        {redemptionInstructions && (
          <div>
            <strong>
              <FormattedMessage id="RenderCouponOffer.redemptionInstructions" />
            </strong>
            {redemptionInstructions}
          </div>
        )}
      </div>
      <div className={css.blockBottomInfo}>
        {rewardExpirationDate && (
          <div className={css.blockInfoLeft}>
            <Icons name="calendar" />
            <div className={css.blockInfo}>
              <span>
                <FormattedMessage id="RenderCouponOffer.expirationDate" />
              </span>
              <p>{moment.unix(rewardExpirationDate).format('MM/DD/YYYY')}</p>
            </div>
          </div>
        )}

        <div className={css.blockInfoLeft} style={{ justifyContent: 'end' }}>
          <span className={css.talentExlusive}>
            <span className={css.ribbon}>
              <FormattedMessage id="RenderCouponOffer.talentExclusive" />
            </span>
          </span>
        </div>
      </div>
      {isOwnListing && (
        <ListingPageActionButtons
          listingId={listing?.id?.uuid}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      )}
    </div>
  );
}

function RenderCouponOffer({ profileImageIcon, currentUserListingSports }) {
  const rewardListings = useSelector(rewardListingsSelector);
  const { isOwnListing, history, routeConfiguration } = useListingPageContext();
  const dispatch = useDispatch();

  if (!isArrayLength(rewardListings)) {
    return <></>;
  }
  return (
    <div className={classNames(css.talentOptions, css.brandPostings)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="RenderCouponOffer.heading" />
            </h2>
          </div>
        </div>
        <div className={css.sectionContent}>
          <div className={css.brandCouponSec}>
            <Slider
              {...{
                ...sliderSettings,
                // arrows: isHovered,
              }}
            >
              {isArrayLength(rewardListings) &&
                rewardListings
                  .reduce((acc, listing) => {
                    const listingSports = getListingSports(listing) ?? [];
                    const rewardAvailability = getRewardAvailability(listing);
                    const userSports = currentUserListingSports ?? [];
                    // Treat undefined rewardAvailability as non-CERTAIN (include listing)
                    if (
                      rewardAvailability !== RewardAvailability.CERTAIN ||
                      listingSports.some(sport => userSports?.includes(sport))
                    ) {
                      // For 'certain' or other cases, include the listing
                      acc.push(listing);
                    }

                    return acc;
                  }, [])
                  .map(listing => {
                    return (
                      <Step
                        key={listing?.id?.uuid ?? `fallback-${Math.random()}`}
                        listing={listing}
                        isOwnListing={isOwnListing ?? false}
                        profileImageIcon={profileImageIcon}
                        history={history}
                        routeConfiguration={routeConfiguration}
                        dispatch={dispatch}
                      />
                    );
                  })}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

RenderCouponOffer.defaultProps = {
  sliderSettings,
};

export default RenderCouponOffer;
